import type { JSX } from "react";
import { useNavigate } from "react-router-dom";
import { Screen } from "../components/ui/editorial/Screen.js";
import { Topline } from "../components/ui/editorial/Topline.js";

export function Privacy(): JSX.Element {
  const navigate = useNavigate();

  return (
    <Screen tone="paper">
      <div className="px-[22px] pt-[48px]">
        <Topline left="COMPANION" right="приватность" />
      </div>

      <div className="flex flex-1 flex-col px-[22px] pt-[30px] pb-[24px]">
        <button
          type="button"
          onClick={() => {
            navigate(-1);
          }}
          className="self-start editorial-meta text-ink/55 hover:text-ink transition-colors"
        >
          ← назад
        </button>

        <div className="mt-[22px] editorial-kicker text-accent">Политика приватности</div>

        <h1 className="mt-[14px] font-display font-light leading-[1] tracking-[-0.028em] text-ink text-[40px]">
          Что мы <em className="italic text-velvet">храним</em>,
          <br />а что — нет.
        </h1>

        <div className="mt-[28px] font-display font-light text-[16px] leading-[1.58] text-ink/85 space-y-[14px]">
          <p>
            Мы собираем минимум: имя, возраст, город, ответы из анкеты Спутника и ваши отклики на
            присланные профили. Этого хватает, чтобы подбирать вам правильного человека и улучшать
            подбор со временем.
          </p>

          <p>
            <strong className="font-normal text-ink">Что мы не делаем:</strong> не продаём данные
            третьим лицам, не показываем таргет-рекламу, не делимся анкетой без вашего согласия.
          </p>

          <p>
            <strong className="font-normal text-ink">Безопасность:</strong> данные хранятся в
            зашифрованном виде. Авторизация — через Telegram, без паролей и сторонних SSO.
          </p>

          <p>
            <strong className="font-normal text-ink">Удаление:</strong> в любой момент в «редакции»
            можно поставить паузу или стереть профиль. После удаления анкета и переписка со
            Спутником уничтожаются в течение суток.
          </p>

          <p>
            <strong className="font-normal text-ink">Геолокация:</strong> запрашивается только с
            вашего явного согласия и только в момент выбора места встречи. Координаты не сохраняются
            — используются на лету для расчёта расстояний до курируемых заведений.
          </p>

          <p>
            <strong className="font-normal text-ink">Контакт:</strong> все вопросы — Спутнику в
            редакции или напрямую в поддержку Telegram-бота.
          </p>
        </div>

        <p className="mt-[32px] editorial-meta text-ink/50">Редакция № I · апрель 2026</p>
      </div>
    </Screen>
  );
}
